/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockExclamation = createReactComponent("outline", "clock-exclamation", "IconClockExclamation", [["path", { "d": "M20.986 12.502a9 9 0 1 0 -5.973 7.98", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

export { IconClockExclamation as default };
//# sourceMappingURL=IconClockExclamation.mjs.map
